import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, SparklesIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function GiftCardSection() {
  const {
    t
  } = useLanguage();
  return <section id="gift-card" className="py-12 md:py-24 bg-brand-cream relative border-y border-brand-gold/10" data-id="element-219" data-mp="1ibvxsbuzmzac">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-220" data-mp="1n9p18x4wpf6x">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center" data-id="element-221" data-mp="19b7i7cpy4qvc">
          {/* Copy */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-222" data-mp="1df5gxmbczznv">
            <div className="flex items-center gap-3 mb-4" data-id="element-223" data-mp="2yqx95serhdfu">
              <GiftIcon className="w-6 h-6 text-brand-gold" data-id="element-224" data-mp="2yq5m55z8co16" />
              <span className="text-sm uppercase tracking-widest text-brand-gold font-semibold" data-id="element-225" data-mp="3jsdnqurlv6qt">
                {t('services.gift_title')}
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-serif text-brand-brown mb-4 md:mb-6" data-id="element-226" data-mp="3sl8vpw8gjgka">
              {t('services.gift_desc')}
            </h2>
            <div className="w-16 h-1 bg-brand-gold mb-8" data-id="element-227" data-mp="3okf7f1r3rzqv"></div>
            <p className="text-lg text-brand-charcoal mb-8" data-id="element-228" data-mp="30tszrbl0ghhe">
              Porque cuidarte es un acto de amor propio, no de vanidad.
            </p>
            <a href="https://wa.me/15513328938?text=Hola%2C%20me%20gustar%C3%ADa%20comprar%20una%20Gift%20Card" target="_blank" rel="noopener noreferrer" className="btn-gold-animated relative overflow-hidden inline-flex items-center gap-2 text-white px-8 py-3 rounded-sm font-medium transition-all duration-300 shadow-lg shadow-brand-gold/30 ring-1 ring-brand-gold-light/40 hover:shadow-brand-gold/50 hover:-translate-y-0.5 text-sm" data-id="element-229" data-mp="2vx2hqipnbbtc">
              <span aria-hidden="true" className="sheen pointer-events-none absolute inset-y-0 -left-1/3 w-1/3 skew-x-[-20deg] bg-white/25 blur-md" data-id="element-230" data-mp="3dzrhnyey45r0" />
              <SparklesIcon className="relative w-4 h-4" data-id="element-231" data-mp="3mz4qcov8wqao" />
              <span className="relative" data-id="element-232" data-mp="3rxohr4slyuaf">{t('services.gift_btn')}</span>
            </a>
          </motion.div>

          {/* Card visual */}
          <motion.div className="group relative" initial={{
          opacity: 0,
          y: 30,
          rotate: -2
        }} whileInView={{
          opacity: 1,
          y: 0,
          rotate: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.7,
          ease: [0.22, 1, 0.36, 1]
        }} whileHover={{
          y: -8
        }} data-id="element-233" data-mp="2v909h06p2le7">
            <div className="relative overflow-hidden rounded-sm border border-brand-gold/30 shadow-lg" data-id="element-234" data-mp="28xp786ujctym">
              <img src="https://cdn.magicpatterns.com/uploads/bFyih1rHKeAGvEU9rUU7qp/gift_card_1.png" alt="Tairu Aesthetics Gift Card - The Golden Glow" loading="lazy" className="w-full transition-transform duration-[1200ms] ease-out group-hover:scale-105" data-id="element-235" data-mp="240p2bz9f9x93" />
              <motion.div className="pointer-events-none absolute inset-y-0 -left-1/3 w-1/3 bg-gradient-to-r from-transparent via-white/35 to-transparent" initial={{
              x: '-50%',
              opacity: 0
            }} whileInView={{
              x: '450%',
              opacity: 1
            }} viewport={{
              once: true,
              amount: 0.3
            }} transition={{
              duration: 1.6,
              delay: 0.6,
              ease: 'easeInOut'
            }} data-id="element-236" data-mp="1q1z58jmlrxkq" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}